import { render, staticRenderFns } from "./qs2-09.vue?vue&type=template&id=3d7252b9&scoped=true&"
import script from "./qs2-09.vue?vue&type=script&lang=js&"
export * from "./qs2-09.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7252b9",
  null
  
)

export default component.exports